import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  AddCardResponse,
  BookingPaymentData,
  CompleteBookingInfo,
  GetPaymentData,
  HccDetailsResponse,
  PaymentCardForBe
} from 'src/app/shared/models/payment.model';
import { Room } from 'src/app/shared/models/room.model';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {
  public bookingPaymentData: BookingPaymentData;

  constructor(private http: HttpClient) {}

  getHost(): string {
    const domElement = document.getElementsByTagName('base')[0];
    return domElement ? domElement.href : null;
  }

  getPaymentUrl(data: GetPaymentData): Observable<HccDetailsResponse> {
    data.host = this.getHost();
    return this.http.post<HccDetailsResponse>(
      `${environment.apiUrl}payments/${data.accountId}/hccdetails`, data
    );
  }

  completeBooking(inventoryReservationId): Observable<CompleteBookingInfo> {
    return this.http.post<CompleteBookingInfo>(
      `${environment.apiUrl}Rooms/inventoryreservations/${inventoryReservationId}/confirm`,
      this.bookingPaymentData
    );
  }

  addCard(cardInfo: PaymentCardForBe): Observable<AddCardResponse> {
    return this.http.post<AddCardResponse>(`${environment.apiUrl}payments/cards`, Object.assign({}, cardInfo, { host: this.getHost() }));
  }

  setBookingPaymentData(data: BookingPaymentData): void {
    this.bookingPaymentData = data;
  }

  isBillingAddressRequired(roomId: Room['centreNumber']): Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiUrl}payments/centre/${roomId}/isbillingaddressrequired`);
  }
}
